import {
  checkDevice,
  setDisplay,
  setModalMessage,
  showToast,
  openCommonModal,
  disableButton,
  closeModal,
  closeMyModal,
  getCookie,
  setCookie,
  reformatPaste,
  getPodClass,
  validateEmail,
  getGenreList,
  getLangList,
  getCountryList,
  getLangIndex,
  getCountryIndex,
  getCountryCode,
  getGenre,
  getLangName,
  getCountryName,
} from "./common";
import phPodcast from "url:../images/podcast.svg";
const podcastFeedParser = require("@podverse/podcast-feed-parser");
var userProfile;
var trans;
var currentUserId;
var ui;
var newUser;
var authListener;
var email;
var iconFile, userImgFile;
var currentSeg = 0;
var verifiedStepList = [];
var segmentList;
var podcast;
var mainInfoValidation = [false, false, false];
var oldFeed = "";
var verifyRef;
var iconRef;
$(document).ready(function () {
  $(function () {
    initViews();
    translatePage();
    reformatPaste();
    initListeners();
    userProfile = {
      userId: null,
      email: null,
      profile_Image: null,
      name: null,
      lowCaseName: null,
      isCreator: true,
      date_created: null,
    };
    getUser();
    window.onclick = function (event) {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };
    checkDevice();
  });
});

function getUser() {
  authListener = firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      currentUserId = firebase.auth().currentUser.uid;
      if (firebase.auth().currentUser.email) {
        email = firebase.auth().currentUser.email;
      } else {
        email = firebase.auth().currentUser.phoneNumber;
      }
      getProfileInfo();
    } else {
      initUserLogin();
    }
  });
}

function initUserLogin() {
  setDisplay(registerUser, "block");
  btnEmailLogin.addEventListener(
    "click",
    function () {
      setDisplay(emailOptions, "block");
      setDisplay(phoneOptions, "none");
    },
    false
  );

  btnPhoneLogin.addEventListener(
    "click",
    function () {
      initPhoneOption();
      setDisplay(emailOptions, "none");
      setDisplay(phoneOptions, "block");
    },
    false
  );

  btnNext.addEventListener(
    "click",
    function () {
      if (etEmail.value && etEmail.value.includes("@")) {
        setDisplay(loading, "block");
        setDisplay(btnNext, "none");
        setDisplay(etPassword, "block");
        setDisplay(btnLogin, "block");
        checkEmail(etEmail.value);
      } else {
        showToast(trans.errorEmail);
        setDisplay(loading, "none");
      }
    },
    false
  );

  btnLogin.addEventListener(
    "click",
    function () {
      if (!etPassword.value) {
        showToast(trans.errorPass);
        return;
      }
      if (newUser) {
        createUserEmailPass(etEmail.value, etPassword.value);
      } else {
        loginUserEmailPass(etEmail.value, etPassword.value);
      }
    },
    false
  );
}

function getProfileInfo() {
  var userRef = firebase.database().ref(`Users/${currentUserId}/info`);
  userRef.once("value").then(function (data) {
    if (data.val()) {
      var userInfo = data.val();
      userProfile.email = userInfo.email;
      userProfile.name = userInfo.name;
      userProfile.lowCaseName = userInfo.name.toLowerCase();
      if (userInfo.djImage) {
        userProfile.profile_Image = userInfo.djImage;
      } else if (userInfo.profile_Image) {
        userProfile.profile_Image = userInfo.profile_Image;
      }
    } else {
      registerUserInfo();
    }
  });
}
function registerUserInfo() {
  inImageUpload.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      userImgFile = this.files[0];
      imgUser.src = URL.createObjectURL(userImgFile); // set src to blob url
    }
  });
  registerModal
    .querySelector(".img-thumbnail")
    .addEventListener("click", function () {
      uploadImage("register");
    });
  $(document).ready(function () {
    inName.focus();
  });

  var loader = document.getElementById("loadingInfo");
  setDisplay(registerModal, "block");

  btnRegister.addEventListener(
    "click",
    function () {
      if (inName.value) {
        setDisplay(loader, "block");
        disableButton(btnRegister, true);
        var userName = inName.value;
        var time = new Date().getTime();
        var userInfo = {
          email: email,
          name: userName,
          lowCaseName: userName.toLowerCase(),
          profile_Image: null,
          name_change: "no",
          isPlaying: false,
          date_created: time,
        };
        if (uploadFile) {
          var filePath =
            "User Profile Images/" + currentUserId + "/Images/Profile Pic";
          var storageRef = firebase.storage().ref().child(filePath);
          var uploadTask = storageRef.put(uploadFile);
          uploadTask.on(
            "state_changed",
            function (snapshot) {},
            function (error) {
              switch (error.code) {
                case "storage/unauthorized":
                  // User doesn't have permission to access the object
                  showToast(trans.errorStoragePermission);
                  break;
                case "storage/canceled":
                  showToast(trans.errorUploadCanceled);
                  break;
                case "storage/unknown":
                  // Unknown error occurred, inspect error.serverResponse
                  showToast(trans.errorRegister);
                  break;
              }
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
            },
            function () {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  //console.log('File available at', downloadURL);
                  userInfo.profile_Image = downloadURL;
                  var userRef = firebase
                    .database()
                    .ref("Users/" + currentUserId + "/info");
                  userRef.set(userInfo, function (error) {
                    if (error) {
                      //message failed
                      showToast(trans.errorRegister);
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                    } else {
                      //message sent
                      //console.log("****uploaded user info***");

                      setDisplay(registerModal, "none");
                      setDisplay(loader, "none");
                      disableButton(btnRegister, false);
                      showToast(trans.thankRegister);
                      getProfileInfo();
                      setDisplay(registerRadio, "block");
                    }
                  });
                });
            }
          );
        } else {
          //console.log("id : " + currentChatId);

          var userRef = firebase
            .database()
            .ref("Users/" + currentUserId + "/info");
          userRef.set(userInfo, function (error) {
            if (error) {
              //message failed
              showToast(trans.errorRegister);
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
            } else {
              //message sent
              setDisplay(registerModal, "none");
              setDisplay(loader, "none");
              disableButton(btnRegister, false);
              showToast(trans.thankRegister);
              getProfileInfo();
            }
          });
        }
      } else {
        inName.focus();
        showToast(trans.errorProvideName);
      }
    },
    false
  );
}
function initViews() {
  segmentList = mainContent.querySelectorAll(".segments .seg");
  for (let index = 0; index < segmentList.length; index++) {
    verifiedStepList.push(false);
  }
  podcast = getPodClass();
}
function initListeners() {
  btnTranslate.addEventListener("click", function () {
    showDropdown();
  });
  aEn.addEventListener("click", function () {
    translatePage("en");
  });
  aEs.addEventListener("click", function () {
    translatePage("es");
  });

  downloadApp.querySelector(".close").addEventListener("click", function () {
    closeModal("downloadApp");
  });
  registerModal
    .querySelector(".img-thumbnail")
    .addEventListener("click", function () {
      inImageUpload.click();
    });
  myModal.querySelector(".close").addEventListener("click", function () {
    closeMyModal();
    goHome();
  });
  myModal.querySelector(".btnBlue").addEventListener("click", function () {
    closeMyModal();
    goHome();
  });
  btnNextSeg.addEventListener("click", function () {
    checkInput();
  });

  btnCancel.addEventListener("click", function () {
    if (currentSeg == 0) {
      window.location.assign("../index.html");
      return;
    }

    displaySegment(currentSeg, --currentSeg, "flex");
    disableButton(btnNextSeg, false);
    setButtonText(currentSeg);
  });
  initPodIconSeg();
  initHostInfoSeg();
  initMainInfoSeg();
  initFeedSeg();
  initOptionalSeg();
}

function initOptionalSeg() {
  inPodWeb.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblPodWeb.style.opacity;
    if (text == "") {
      $(lblPodWeb).fadeTo(200, 0);
    } else if (opas == 0 || opas == "") {
      $(lblPodWeb).fadeTo(200, 1);
    }
  });

  inPodPhone.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblPodPhone.style.opacity;
    if (text == "") {
      $(lblPodPhone).fadeTo(200, 0);
    } else if (opas == 0 || opas == "") {
      $(lblPodPhone).fadeTo(200, 1);
    }
  });
}

function initFeedSeg() {
  inPodFeed.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblPodFeed.style.opacity;
    if (text == "" || !this.checkValidity()) {
      $(lblPodFeed).fadeTo(200, 0);
      disableButton(btnNextSeg, true);
      if (podPlayer.paused) {
        disableButton(btnPlayFeed, true);
      }
    } else if (opas == 0 || opas == "") {
      $(lblPodFeed).fadeTo(200, 1);
      disableButton(btnNextSeg, false);
      disableButton(btnPlayFeed, false);
    }
  });

  btnPlayFeed.addEventListener("click", function () {
    var feed = inPodFeed.value.trim();
    if (podPlayer.paused) {
      if (oldFeed == feed) {
        podPlayer.play();
      } else {
        oldFeed = feed;
        setDisplay(spFeedLoading, "inline-block");
        btnPlayFeed.textContent = trans.loadingFeed;
        initPodAudio(feed);
      }
    } else {
      podPlayer.pause();
    }
  });

  podPlayer.onended = function () {
    btnPlayFeed.textContent = trans.testFeed;
    setDisplay(spFeedLoading, "inline-block");
  };

  podPlayer.onerror = function () {
    btnPlayFeed.textContent = trans.tryAgain;
    setDisplay(spFeedLoading, "none");
  };

  podPlayer.oncanplay = function () {
    btnPlayFeed.textContent = trans.playing;
    podPlayer.play();
    setDisplay(spFeedLoading, "none");
  };

  podPlayer.onplay = function () {
    btnPlayFeed.textContent = trans.pause;
    setDisplay(spFeedLoading, "none");
  };

  podPlayer.onpause = function () {
    btnPlayFeed.textContent = trans.testFeed;
  };
}

async function initPodAudio(feed) {
  podPlayer.innerHTML = "";
  if (feed) {
    var pod;
    try {
      pod = await podcastFeedParser.getPodcastFromURL(feed);
    } catch {
      setDisplay(spFeedLoading, "none");
      btnPlayFeed.textContent = trans.tryAgain;
    }
    if (pod == null) {
      setDisplay(spFeedLoading, "none");
      btnPlayFeed.textContent = trans.tryAgain;
      return;
    }
    const episodes = pod.episodes;
    var episodeLink;
    if (episodes != null && episodes.length > 0) {
      episodeLink = episodes[0].enclosure.url;
    } else {
      setDisplay(spFeedLoading, "none");
    }
    if (episodeLink == null) {
      setDisplay(spFeedLoading, "none");
      return;
    }
    var source = document.createElement("source");
    source.src = episodeLink;
    podPlayer.appendChild(source);
    podPlayer.load();
  } else {
    setDisplay(spFeedLoading, "none");
  }
}
function initMainInfoSeg() {
  inHostName.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblHostName.style.opacity;
    if (text == "") {
      checkMainInput(true, 0, 1, 2);
      $(lblHostName).fadeTo(200, 0);
    } else if (opas == 0 || opas == "") {
      $(lblHostName).fadeTo(200, 1);
      checkMainInput(false, 0, 1, 2);
    }
  });

  inPodTitle.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblPodTitle.style.opacity;
    if (text == "") {
      checkMainInput(true, 1, 0, 2);
      $(lblPodTitle).fadeTo(200, 0);
    } else if (opas == 0 || opas == "") {
      $(lblPodTitle).fadeTo(200, 1);
      checkMainInput(false, 1, 0, 2);
    }
  });

  inPodDesc.addEventListener("input", function (evt) {
    var text = this.value.trim();
    var opas = lblPodDesc.style.opacity;
    if (text == "") {
      checkMainInput(true, 2, 0, 1);
      $(lblPodDesc).fadeTo(200, 0);
    } else if (opas == 0 || opas == "") {
      $(lblPodDesc).fadeTo(200, 1);
      checkMainInput(false, 2, 0, 1);
    }
  });

  var genres = getGenreList(trans.en);
  if (selGenre.children.length > 0) {
    selGenre.innerHTML = "";
  }
  genres.forEach((genre) => {
    var option = document.createElement("option");
    option.textContent = genre;
    selGenre.appendChild(option);
  });
  var langs = getLangList(trans.en);
  if (selPodLang.children.length > 0) {
    selPodLang.innerHTML = "";
  }
  langs.forEach((lng) => {
    var option = document.createElement("option");
    option.textContent = lng;
    selPodLang.appendChild(option);
  });

  selPodLang.selectedIndex = getLangIndex(trans.en);

  var countryList = getCountryList(trans.en);
  if (selPodCountry.children.length > 0) {
    selPodCountry.innerHTML = "";
  }
  countryList.forEach((c) => {
    var option = document.createElement("option");
    option.textContent = c;
    selPodCountry.appendChild(option);
  });

  $.getJSON("https://ipapi.co/json/", function (data) {
    if (data.country) {
      selPodCountry.selectedIndex = getCountryIndex(data.country.toUpperCase());
    }
  });
}

function checkMainInput(isEmpty, current, x, y) {
  if (isEmpty) {
    mainInfoValidation[current] = false;
    disableButton(btnNextSeg, true);
  } else {
    mainInfoValidation[current] = true;
    if (mainInfoValidation[x] && mainInfoValidation[y]) {
      disableButton(btnNextSeg, false);
    }
  }
}

function initHostInfoSeg() {
  inAdminEmail.addEventListener("input", function (evt) {
    var text = this.value.trim();
    if (text == "") {
      disableButton(btnNextSeg, true);
    } else {
      disableButton(btnNextSeg, !text.includes("@") || !validateEmail(text));
    }
  });
}
function checkInput() {
  switch (currentSeg) {
    case 0:
      checkIcon();
      break;
    case 1:
      checkHostInfo();
      break;
    case 2:
      checkMainInfo();
      break;
    case 3:
      checkFeed();
      break;
    case 4:
      checkOptional();
      break;
    case 5:
      registerPodcast();
      break;
  }
}

function registerPodcast() {
  var pVerifying = podRegisteringModal.querySelector(".msg");
  setDisplay(podRegisteringModal, "flex");
  verifyRef = firebase.database().ref(`verify/podcast/`);
  var podId = verifyRef.push().key;
  podcast.uid = currentUserId;
  if (iconFile) {
    uploadIcon(podId, pVerifying);
  } else {
    uploadInfo(podId, pVerifying);
  }
}
function uploadIcon(podId, pVerifying) {
  pVerifying.innerHTML = trans.uploadingImage.replace("$num%", "");
  iconRef = firebase.storage().ref(`podcast/${podId}/logo`);
  var uploadTask = iconRef.put(iconFile);
  uploadTask.on(
    "state_changed",
    function (snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      if (progress) {
        pVerifying.innerHTML = trans.uploadingImage.replace("$num%", progress);
      }
    },
    function (error) {
      var errorMess;
      switch (error.code) {
        case "storage/unauthorized":
          errorMess = trans.errorImage;
          break;
        case "storage/canceled":
          errorMess = trans.errorUploadCancel;
          break;
        case "storage/unknown":
          errorMess = trans.errorUnknown;
          break;
      }

      setDisplay(podRegisteringModal, "none");
      showToast(errorMess);
    },
    function () {
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        podcast.icon = downloadURL;
        uploadInfo(podId, pVerifying);
      });
    }
  );
}

function uploadInfo(podId, pVerifying) {
  pVerifying.textContent = trans.registeringPod;
  podcast.date = new Date().getTime();
  verifyRef.child(podId).set(podcast, function (error) {
    if (error) {
      showToast(trans.errorPodRegister);
      setDisplay(podRegisteringModal, "none");
    } else {
      var userPodRef = firebase
        .database()
        .ref(`Users/${currentUserId}/podcast/${podId}`);
      userPodRef.set(false, function (error) {
        setDisplay(podRegisteringModal, "none");
        if (error) {
          showToast(trans.errorPodRegister);
          verifyRef.child(podId).remove();
          if (podcast.icon && iconRef != null) {
            iconRef.delete();
            podcast.icon = null;
          }
        } else {
          modalMessage.innerHTML = trans.registerSuccess.replace(
            "$name",
            podcast.title
          );
          setDisplay(myModal, "flex");
        }
      });
    }
  });
}

function goHome() {
  window.location.assign("../chat.html");
}

function checkOptional() {
  var web = inPodWeb.value.trim();
  var phone = inPodPhone.value.trim();
  podcast.web = web != "" ? web : null;
  podcast.phone = phone != "" ? phone : null;
  nextStep(verifiedStepList[currentSeg + 1]);

  initConfirmData();
}

function initConfirmData() {
  divPodEmail.textContent = podcast.email;
  divPodHost.textContent = podcast.host;
  divPodTitle.textContent = podcast.title;
  divPodDesc.textContent = podcast.desc;
  divPodGenre.textContent = getGenre(trans.en, podcast.genre);
  divPodLang.textContent = getLangName(trans.en, podcast.lang);
  divPodCountry.textContent = getCountryName(
    trans.en,
    getCountryIndex(podcast.country.toUpperCase())
  );
  divPodFeed.textContent = podcast.feed;
  divPodWeb.textContent = podcast.web;
  divPodPhone.textContent = podcast.phone;

  imgPodIcon.src = iconFile ? URL.createObjectURL(iconFile) : phPodcast;
  disableButton(btnNextSeg, false);
}

function checkFeed() {
  var feed = inPodFeed.value.trim();
  if (feed == "") {
    return;
  }
  var podFeedRef = firebase.database().ref("podcast");
  podFeedRef
    .orderByChild("feed")
    .equalTo(feed)
    .once("value", function (data) {
      if (data.exists()) {
        showfeedError();
      } else {
        podcast.feed = feed;
        if (!podPlayer.paused) {
          podPlayer.pause();
        }
        nextStep(verifiedStepList[currentSeg + 1]);
        $(inPodWeb).focus();
        disableButton(btnNextSeg, false);
      }
    });
}

function showfeedError() {
  showToast(trans.errorFeedExists);
  $(inPodFeed).shake();
}
function checkMainInfo() {
  podcast.host = inHostName.value.trim();
  podcast.title = inPodTitle.value.trim();
  podcast.lcTitle = podcast.title.toLowerCase();
  podcast.desc = inPodDesc.value.trim();
  podcast.genre = selGenre.selectedIndex;
  podcast.lang = selPodLang.selectedIndex;
  podcast.country = getCountryCode(selPodCountry.selectedIndex).toLowerCase();
  nextStep(verifiedStepList[currentSeg + 1]);
}

function checkHostInfo() {
  podcast.email = inAdminEmail.value.trim();
  nextStep(verifiedStepList[currentSeg + 1]);
  $(inHostName).focus();
}
function checkIcon() {
  if (iconFile) {
    nextStep(verifiedStepList[currentSeg + 1]);
    inAdminEmail.value = inAdminEmail.value;
    $(inAdminEmail).focus();
  } else {
    $(imgIcon).shake();
    $(btnUploadLogo).shake();
  }
}

function nextStep(enableNext) {
  verifiedStepList[currentSeg] = true;
  disableButton(btnNextSeg, !enableNext);
  displaySegment(currentSeg++, currentSeg, "flex");
  setButtonText();
}

function setButtonText() {
  const totalTabs = segmentList.length - 1;
  if (currentSeg < totalTabs) {
    btnNextSeg.textContent = trans.next;
    if (currentSeg == 0) {
      btnCancel.textContent = trans.cancel;
    } else {
      btnCancel.textContent = trans.back;
    }
  } else {
    btnNextSeg.textContent = trans.title;
    btnCancel.textContent = trans.back;
  }
}

function displaySegment(oldPos, pos, display) {
  if (oldPos != -1) {
    segmentList[oldPos].style.display = "none";
  }
  if (display == "flex") {
    $(segmentList[pos]).fadeIn("slow");
  } else {
    segmentList[pos].style.display = display;
  }
}

function initPodIconSeg() {
  inIcon.addEventListener("change", function () {
    if (this.files && this.files[0]) {
      iconFile = this.files[0];
      imgIcon.src = URL.createObjectURL(iconFile); // set src to blob url
    }
    // else {
    //   imgIcon.src = iconFile != null?iconFile:phPodcast;
    // }
  });

  btnUploadLogo.addEventListener("click", function () {
    inIcon.click();
  });
  imgIcon.addEventListener("click", function () {
    inIcon.click();
  });
}
function showDropdown() {
  document.getElementById("langDropdown").classList.toggle("show");
}
jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 4;
  intDistance = intDistance || 2;
  intDuration = intDuration || 500;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};
var language = {
  eng: {
    idiom: "En",
    title: "Register podcast",
    en: "en",
    register: "You need to be logged in to register your podcast.",
    continue: "Continue with...",
    phone: "Phone",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    login: "LOGIN",
    infoLog:
      "We will use the information above to log you in or to create a new account if you do not have one.",
    disclaimer:
      'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
    podInfo: "Podcast information",
    uploadPodIcon: "Upload an image that best represents your podcast",
    podIcon: "Podcast icon",
    uploadLogo: "Upload logo",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    downloadMess:
      "ChatMurcianys is available for your device on the Google PlayStore",
    download: "Descargar",
    close: "Close",
    loading: "Loading",
    errorEmail: "Please provide a valid email address",
    welcomeBack: "Welcome back! Enter the password for this account",
    createPass: "Create a password to secure your account",
    creatingAcc: "Creating account. Please wait...",
    uploadImage: "Upload Image",
    whatName: "What name would you like to use?",
    registerMe: "Register",
    name: "Name",
    thankRegister: "Thank you for registering!",
    errorRegister: "Error registering. Try again later.",
    errorPass: "Please provide a password for your account.",
    profileImage: "Profile image",
    errorStoragePermission:
      "You don't have permission to upload this image. Upload a different image.",
    errorUploadCanceled: "The upload was canceled",
    errorProvideName: "Please provide your name",
    aboutYou: "About you",
    requireEmail:
      "Provide a valid email where we can contact you <br /><br />(Note: it will not be visible to your audience)",
    emailIcon: "Email icon",
    requirePodInfo: "Tell us about your podcast",
    hostName: "Host name",
    podTitle: "Podcast title",
    desc: "Description",
    genre: "Genre",
    langauge: "Language",
    country: "Country",
    requirePodFeed:
      "Provide your podcast feed URL <br />Example:<br />https://example.fm/s/55de8b4/podcast/rss",
    xmlRssFeedUrl: "XML/RSS feed URL",
    testFeed: "Test feed",
    feedTest:
      "Test your podcast before proceeding.<br />Did anything play? (Do not worry about this step if you have not uploaded any episodes to your podcast)",
    loadingFeed: "Loading feed",
    tryAgain: "Retry",
    playing: "Playing",
    pause: "Pause",
    podOptionalInfo: "Podcast optional information",
    podOptional:
      "La siguiente información es opcional y se compartirá con tu audiencia.",
    webAddress: "Website address",
    phoneNum: "Phone number",
    errorFeedExists: "This feed is already registered",
    verifyInfo: "Verify information",
    confetti: "Confetti",
    registerSuccess:
      'Your application to add $name to ChatMurcianys has been received.<br /> <br />We will notify you when your podcast is registered and ready to share.<br />In the meantime, you can check the status of you application by visiting "My groups" and make any changes if needed',
    registeringPod: "Registering podcast…",
    uploadingImage: "Uploading image…$num%",
    errorUnknown: "Unknown error occur. Try again later",
    errorImage: "You don't have permission to upload this image",
    errorUploadCancel: "You canceled the upload",
    errorPodRegister: "Error registering",
  },
  es: {
    idiom: "Es",
    title: "Registrar podcast",
    en: "es",
    register: "Necesitas entrar a tu cuenta para poder registrar tu podcast",
    continue: "Continua con...",
    phone: "Teléfono",
    email: "Correo Electrónico",
    password: "Contraseña",
    rememberMe: "Recúerdame",
    login: "Iniciar Sesión",
    infoLog:
      "Utilizaremos la información anterior para iniciar sesión o para crear una nueva cuenta si no tiene una.",
    disclaimer:
      'Al continuar, aceptas nuestros <a href="about.html#terms">Términos y Condiciones</a>, y <a href="about.html">Política de Seguridad</a>',
    podInfo: "Información del podcast",
    uploadPodIcon: "Sube una imagen que mejor represente tu podcast",
    podIcon: "Icono de podcast",
    uploadLogo: "Subir imagen",
    cancel: "Cancelar",
    next: "Siguente",
    back: "Regresar",
    downloadMess:
      "ChatMurcianys está disponible para tu dispositivo en Google PlayStore",
    download: "Descargar",
    close: "Cerrar",
    loading: "Cargando",
    errorEmail: "Por favor provee un correo electrónico valido",
    welcomeBack: "¡Bienvenido de nuevo! Ingrese la contraseña para esta cuenta",
    createPass: "Crea una contraseña para proteger tu cuenta",
    creatingAcc: "Creando la cuenta. Por favor espere...",
    uploadImage: "Subir Imagen",
    whatName: "¿Que nombre te gustaria usar?",
    registerMe: "Registrarme",
    name: "Nombre",
    thankRegister: "¡Gracias por registrarte!",
    errorRegister: "Error registrandote. Inténtalo de nuevo más tarde.",
    errorPass: "Por favor, proporciona una contraseña para tu cuenta.",
    profileImage: "Foto de perfil",
    errorStoragePermission:
      "No tienes permiso de subir esta imagen. Sube una imagen diferente",
    errorUploadCanceled: "La carga fue cancelada",
    errorProvideName: "Por favor provee tu nombre",
    aboutYou: "Acerca de ti",
    requireEmail:
      "Provee un correo electrónico válido donde podamos comunicarnos contigo<br /><br />(Nota: no será visible para tu audiencia)",
    emailIcon: "Icono de correo electrónico",
    requirePodInfo: "Cuéntanos sobre tu podcast",
    hostName: "Nombre de presentador",
    podTitle: "Título del podcast",
    desc: "Descripción",
    genre: "Género",
    language: "Idioma",
    country: "País",
    requirePodFeed:
      "Proporciona el URL de la fuente de tu podcast<br />Ejemplo:<br />https://example.fm/s/55de8b4/podcast/rss",
    xmlRssFeedUrl: "URL de la fuente XML / RSS",
    testFeed: "Testear la fuente",
    feedTest:
      "Prueba el sonido del podcast antes de continuar.<br />¿Se reprodujo algo? (No te preocupes por este paso si no has subido episodios a tu podcast).",
    loadingFeed: "Cargando fuente",
    tryAgain: "Reintentar",
    playing: "Reproduciendo",
    pause: "Pausar",
    podOptionalInfo: "Información opcional del podcast",
    podOptional:
      "La siguiente información es opcional y se compartirá con tu audiencia.",
    webAddress: "Dirección del sitio web",
    phoneNum: "Número de teléfono",
    errorFeedExists: "Esta fuente del podcast ya está registrada",
    verifyInfo: "Verificar información",
    confetti: "Confeti",
    registerSuccess:
      'Hemos recibido tu solicitud para agregar $name a ChatMurcianys.<br /><br />Te notificaremos cuando tu podcast esté registrada y lista para compartir.<br />Mientras tanto, puedes verificar el estado de tu solicitud visitando "Mis grupos" y hacer cualquier cambio necesario.',
    registeringPod: "Registrando el podcast…",
    uploadingImage: "Subiendo imagen…$num%",
    errorUnknown: "Hubo un error desconocido. Intenta nuevamente más tarde",
    errorImage: "No tienes permiso de subir la imagen.",
    errorUploadCancel: "Has cancelado la carga",
    errorPodRegister: "Hubo un error en la registración",
  },
};
function translatePage(lang) {
  var translate = false;
  if (lang) {
    translate = true;
    if (lang.includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      aEn.className = aEn.className.replace(" set", "");
      aEs.className += " set";
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
      document.getElementsByTagName("html")[0].setAttribute("lang", "en");
      aEs.className = aEn.className.replace(" set", "");
      aEn.className += " set";
      setCookie("lang", "en", 365);
    }
  } else if (getCookie("lang") != "") {
    if (getCookie("lang").includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className = langs[0].className.replace(" set", "");
      langs[1].className += " set";
      translate = true;
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
    }
  } else if (
    window.navigator.language &&
    window.navigator.language.includes("es")
  ) {
    translate = true;
    trans = language.es;
    document.getElementsByTagName("html")[0].setAttribute("lang", "es");
    aEn.className = aEn.className.replace(" set", "");
    aEs.className += " set";
  } else {
    trans = language.eng;
  }
  if (translate) {
    menuLang.textContent = trans.idiom;
    topHead.querySelector("h1").textContent = trans.title;

    var registerPs = registerUser.querySelectorAll("p");
    registerPs[0].textContent = trans.register;
    registerPs[1].textContent = trans.continue;
    registerPs[2].textContent = trans.infoLog;
    registerPs[3].innerHTML = trans.disclaimer;
    btnPhoneLogin.textContent = trans.phone;
    btnEmailLogin.textContent = trans.email;
    etEmail.placeholder = trans.email;
    etPassword.placeholder = trans.password;
    btnLogin.textContent = trans.login;
    registerUser.querySelector(".boldText").textContent = trans.rememberMe;
    $(".alt-podIcon").attr("alt", trans.podIcon);
    btnUploadLogo.textContent = trans.uploadImage;
    var segmentTitles = mainContent.querySelectorAll(".segments .pTitle");
    segmentTitles[0].textContent = trans.podInfo;
    $((segmentTitles[1].innerHTML = trans.aboutYou));
    $(segmentTitles[2]).text(trans.podInfo);
    $((segmentTitles[3].innerHTML = trans.podInfo));
    $((segmentTitles[4].innerHTML = trans.podOptionalInfo));
    $((segmentTitles[5].innerHTML = trans.verifyInfo));
    var segmentSubtitles = mainContent.querySelectorAll(".segments .pSubtitle");
    segmentSubtitles[0].textContent = trans.uploadPodIcon;
    segmentSubtitles[1].innerHTML = trans.requireEmail;
    segmentSubtitles[2].innerHTML = trans.requirePodInfo;
    segmentSubtitles[3].innerHTML = trans.requirePodFeed;
    segmentSubtitles[4].innerHTML = trans.podOptional;
    downloadApp.querySelector("#modalMessage2").textContent =
      trans.downloadMess;
    downloadApp.querySelector(".btnBlue").textContent = trans.download;
    $(".t-close").attr("title", trans.close);
    $(".t-loading").attr("title", trans.loading);
    if (newUser) {
      divPassInfo.textContent = trans.createPass;
    } else {
      divPassInfo.textContent = trans.welcomeBack;
    }
    //loadingInfo.querySelector("p").textContent = trans.creatingAcc;
    $(".t-creating-acc").text(trans.creatingAcc);
    $(".t-next").text(trans.next);
    $(".alt-profile-img").attr("alt", trans.profileImage);
    registerModal.querySelector(".blueText").textContent = trans.whatName;
    registerModal.querySelector("span").textContent = trans.uploadImage;
    btnRegister.textContent = trans.registerMe;
    inName.placeholder = trans.name;
    $(".ph-email").attr("placeholder", trans.email);
    $(".t-email").attr("title", trans.email);
    $(".alt-emailIcon").attr("alt", trans.emailIcon);
    $(".x-hostName").text(trans.hostName);
    $(".t-hostName").attr("title", trans.hostName);
    $(".p-hostName").attr("placeholder", trans.hostName);

    $(".x-podTitle").text(trans.podTitle);
    $(".t-podTitle").attr("title", trans.podTitle);
    $(".p-podTitle").attr("placeholder", trans.podTitle);

    $(".x-podDesc").text(trans.desc);
    $(".t-podDesc").attr("title", trans.desc);
    $(".p-podDesc").attr("placeholder", trans.desc);

    $(".x-podGenre").text(trans.genre);
    $(".t-podGenre").attr("title", trans.genre);
    $(".p-podGenre").attr("placeholder", trans.genre);

    $(".x-podLang").text(trans.language);
    $(".t-podLang").attr("title", trans.language);
    $(".p-podLang").attr("placeholder", trans.language);

    $(".x-podCountry").text(trans.country);
    $(".t-podCountry").attr("title", trans.country);
    $(".p-podCountry").attr("placeholder", trans.country);

    $(".x-podFeed").text(trans.xmlRssFeedUrl);
    $(".t-podFeed").attr("title", trans.xmlRssFeedUrl);
    $(".p-podFeed").attr("placeholder", trans.xmlRssFeedUrl);

    $(".x-podFeedTest").html(trans.feedTest);
    $(btnPlayFeed).text(trans.testFeed);

    $(".x-podWeb").text(trans.webAddress);
    $(".t-podWeb").attr("title", trans.webAddress);
    $(".p-podWeb").attr("placeholder", trans.webAddress);

    $(".x-podPhone").text(trans.phoneNum);
    $(".t-podPhone").attr("title", trans.phoneNum);
    $(".p-podPhone").attr("placeholder", trans.phoneNum);
    $(".x-email").text(trans.email);
    $(".alt-confetti").attr("alt", trans.confetti);
  }
}
